import { FileUpload } from "@mui/icons-material";
import { Button, Fab } from "@mui/material";
import React from "react";

const UploadFile = ({ label, onUpload, filled = false, iconOnly = false, sx }) => {
  const hiddenFileInput = React.useRef(null);
  const fileInput = (
    <input
      type="file"
      placeholder="Upload"
      onChange={(e) => onUpload(e.target.files[0])}
      ref={hiddenFileInput}
      style={{ display: "none" }}
    />
  );
  if (iconOnly) {
    return (
      <Fab
        color="primary"
        size="medium"
        aria-label={label}
        onClick={() => hiddenFileInput?.current?.click()}
        sx={sx}
      >
        <FileUpload />
        {fileInput}
      </Fab>
    );
  }
  return (
    <Button
      variant={filled ? "contained" : "text"}
      size="small"
      startIcon={<FileUpload fontSize="small" />}
      onClick={() => hiddenFileInput?.current?.click()}
      sx={{
        textTransform: "none",
        fontWeight: 600,
        whiteSpace: "nowrap",
        ...(filled ? { height: 36, borderRadius: "4px", fontSize: "14px" } : {}),
      }}
    >
      {label}
      {fileInput}
    </Button>
  );
};

export default UploadFile;
